import { Instrument, Measurement, MeasurementDetail, Result } from "../../shared/interfaces/Result";

interface Params {
  measurementDetail: MeasurementDetail<Measurement>;
  measurementHistory?: MeasurementDetail<Measurement>[];
  selectedResult?: Result;
  instrument?: Instrument;
  isPartialResult?: boolean;
  position?: number;
  isExpertOrGreater?: boolean;
  isEaEmployee?: boolean;
}

/**
 * Store the measurement in the session storage to be used in the {@link MeasurementPage}.
 * @param measurementDetail The measurement to view.
 * @param measurementHistory The historical measurements.
 * @param selectedResult The selected result.
 * @param instrument The instrument used to take the measurement.
 * @param isPartialResult Whether the measurement is from a partial result.
 * @param position The cable box or spout position.
 * @param isExpertOrGreater True if the user has expert level permission or greater.
 * @param isEaEmployee True if the user is an EA Technology employee.
 */
export function storeMeasurementInSession({
  measurementDetail,
  measurementHistory,
  selectedResult,
  instrument,
  isPartialResult,
  position,
  isExpertOrGreater,
  isEaEmployee,
}: Params) {
  sessionStorage.setItem(
    `measurement-${measurementDetail?.measurement.ComponentAssetId}-${measurementDetail?.measurement.MeasurementType}`,
    JSON.stringify({
      measurementDetail: measurementDetail,
      measurementHistory: measurementHistory,
      selectedResult: selectedResult,
      instrument: instrument,
      isPartialResult: isPartialResult,
      position: position,
      isExpertOrGreater: isExpertOrGreater,
      isEaEmployee: isEaEmployee,
    }),
  );
}
